import type { Dictionary } from '../i18n.js';

/**
 * Words more than one panel uses, so they say the same thing everywhere.
 *
 * The glossary the rest of the dictionary follows — informal "ty", as games are written:
 *
 *   race → wyścig · tour → turniej · cup → puchar · lobby → lobby · host → gospodarz
 *   guest → gość · region (a built-in one) → gotowy obszar · region (drawn) → obszar
 *   checkpoint → punkt kontrolny · start → start · finish → meta · pin → pinezka
 *   driver → kierowca · AI opponent → przeciwnik AI · passkey → klucz dostępu
 *   account → konto · sign in → zaloguj się · leaderboard → ranking · results → wyniki
 *   map tile → kafelek mapy · route → trasa
 */
export const common: Dictionary = {
  Back: 'Wstecz',
  Next: 'Dalej',
  Close: 'Zamknij',
  Cancel: 'Anuluj',
  Save: 'Zapisz',
  Delete: 'Usuń',
  Edit: 'Edytuj',
  Done: 'Gotowe',
  'Try again': 'Spróbuj ponownie',
  'Sign in': 'Zaloguj się',
  'Sign out': 'Wyloguj się',
  Language: 'Język',
  // The connection status and "works without a network" on a card: Polish uses the loanword for both.
  offline: 'offline',
  Ready: 'Gotowe',
};
